/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component, OnInit } from '@angular/core';
import { AuthentificationService } from '../../sharedServices/authentification.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-signout-callback',
  templateUrl: './signout-callback.component.html'
})
export class SignoutCallbackComponent implements OnInit {

  constructor(private readonly authentificationService: AuthentificationService, private readonly router: Router) { }

  ngOnInit() {
    this.authentificationService.completeLogout().then(_ => {

      this.router.navigate(['app-search-fitting'], { replaceUrl: true });
    });
  }

}
